import { useActivitiesStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreActivitiesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { isWebView } from "@b2bportal/core-utilities";
import clsx from "clsx";
import defaultStyles from "./ActivityShopTabs.module.scss";
import { useActivityShopTabs } from "./hooks";

export interface ActivityShopTabsProps extends PlatformComponentProps {
  onTabClick?: (sectionId: string) => void;
}

const COMPONENT_KEY = CoreActivitiesComponent.ActivityShopTabs;

export const ActivityShopTabs = ({
  className,
  onTabClick,
}: ActivityShopTabsProps) => {
  const styles = useActivitiesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { activeTab, handleTabClick, tabs } = useActivityShopTabs({
    onTabClick,
  });

  return (
    <div
      className={clsx(block, className, { [cn("webview")]: isWebView() })}
      id={COMPONENT_KEY}
    >
      <div className={cn("tabs-container")} role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-tab-id={tab.id}
            className={cn("tab", { active: activeTab === tab.id })}
            onClick={() => handleTabClick(tab.id)}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={tab.id}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
